import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';

export const DeleteReplyTemplateValidationSchema = z.object({
  templateId: z.string().min(1),
});
export type TDeleteReplyTemplateValidation = z.infer<typeof DeleteReplyTemplateValidationSchema>;
export type TDeleteReplyTemplatePayload = TDeleteReplyTemplateValidation;
export type TDeleteReplyTemplateResponse = ApiResponse<unknown>;

export const deleteReplyTemplate = (payload: TDeleteReplyTemplatePayload): Promise<TDeleteReplyTemplateResponse> => {
  const url = `/template/${payload.templateId}`;
  return axiosInstance.delete(url);
};

type TUseDeleteReplyTemplateMutationOptions = {
  mutationConfigOptions?: TypedMutationConfig<typeof deleteReplyTemplate, AxiosErrorCustom>;
};

export const useDeleteReplyTemplateMutation = ({ mutationConfigOptions }: TUseDeleteReplyTemplateMutationOptions) => {
  const { ...restConfigOptions } = mutationConfigOptions ?? {};
  return useMutation({
    mutationFn: deleteReplyTemplate,
    ...restConfigOptions,
  });
};
